import { isBrowser } from '../environment/isBrowser';

export function isDatadogSynthetics(): boolean {
  return isBrowser() && window.navigator.userAgent.includes('DatadogSynthetics');
}
